import React, { useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
} from "@mui/material";
import { useNavigate, Link, NavLink } from "react-router-dom";

function Topbar() {
  const navigate = useNavigate();

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <Box className="site_header">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: "100%",
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", padding: "0 25px !important" }}>
          <div className="topbar_left" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate("/dashboard")}>
            <Typography component="h1" sx={{ fontSize: '20px', fontWeight: 700, color: '#fff', margin: 0 }}>
              It's My <span style={{ color: '#8CE352' }}>Wall</span>
            </Typography>
          </div>

          <div className="topbar_nav">
            <NavLink to="/dashboard">Design Engine</NavLink>
            <NavLink to="/recent-designs">My Design</NavLink>
            <NavLink to="/how-it-works">How It Works</NavLink>
            <NavLink to="/manage-profile" state={{ activeTab: "Support" }}>Support</NavLink>
          </div>

          <div className="topbar_right">
            <Box>
              <div
                className="topbar_profile"
                onClick={() => navigate("/manage-profile")}
              >
                <img src="/static/images/avtar.svg" alt="Profile" />
                <span>Albert M</span>
              </div>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Topbar;
